import { PRODUCT_TYPE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/productType'
import {
  BreakpointToAssetNameMap,
  ThemeAssets,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/theme/assets'

// These directories have no plain index.ts — only index.web.ts / index.native.ts.
// Bundlers (Metro, Vite) resolve the platform-specific file correctly via their
// own extension-priority resolution, but tsc's module resolution doesn't apply
// that convention to bare directory imports without a project-wide
// `moduleSuffixes` config, which is out of scope here.
// @ts-expect-error TS2307: cannot find module (resolves fine at build/runtime)
import * as lyraSelectAssets from '../../assets/lyraSelect'
// @ts-expect-error TS2307: cannot find module (resolves fine at build/runtime)
import * as wfmhAssets from '../../assets/wfmh'

/** Return the asset module for the given product type */
type AssetModule = Record<string, string>
const requireAssetModule = (productType: PRODUCT_TYPE): AssetModule => {
  const isLyraSelect = productType === PRODUCT_TYPE.SELECT
  return (isLyraSelect ? lyraSelectAssets : wfmhAssets) as unknown as AssetModule
}

/**
 * Resolve and map asset names to their actual references from the asset module.
 * Update and return the given assets map with the resolved asset paths.
 */
export function resolveAssetPaths(themeAssets: ThemeAssets, productType: PRODUCT_TYPE): ThemeAssets {
  const assetModule = requireAssetModule(productType)
  const assets: ThemeAssets = {}
  Object.entries(themeAssets).forEach(([key, assetConfig]) => {
    const parsedAssetNames: BreakpointToAssetNameMap = { defaultAsset: '' }
    Object.entries(assetConfig.assetNames).forEach(([breakpoint, assetName]) => {
      try {
        const asset = assetModule[assetName as string]
        parsedAssetNames[breakpoint as keyof BreakpointToAssetNameMap] = asset || assetName
      } catch (error) {
        console.warn(`Failed to load asset: ${assetName}`, error)
        parsedAssetNames[breakpoint as keyof BreakpointToAssetNameMap] = assetName
      }
    })
    assets[key] = { ...assetConfig, assetNames: parsedAssetNames }
  })
  return assets
}
